export const QueryKeys = {
  ProductAnalytics: 'product-analytics',
  ProductAnalyticsTotal: 'product-analytics-total',
  ProductAnalyticsRecommendation: 'product-analytics-recommendations',
  FlashSalesData: 'flash-sales-data',
  PromPackagesSale: 'prom-packages-sale',
}